// src/modules/competition/components/CompetitionDetails/index.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

const CompetitionDetails = ({
    currentPeriod,
    pointTarget,
    isUserJoined,
    onJoinClick,
    competitionId,
    competitionName
}) => {
    const startDate = format(new Date(currentPeriod.startDate), 'MMM d, yyyy');
    const endDate = format(new Date(currentPeriod.endDate), 'MMM d, yyyy');

    return (
        <Card className="mb-3">
            <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
                <span>{competitionName}</span>
                <div>
                    <Link
                        to={`/competition/${competitionId}/stats`}
                        className="btn btn-outline-primary me-2"
                    >
                        View Statistics
                    </Link>
                    {!isUserJoined && (
                        <Button
                            variant="primary"
                            onClick={onJoinClick}
                        >
                            Join Competition
                        </Button>
                    )}
                </div>
            </Card.Header>
            <Card.Body>
                <Card.Text>Current Period: {startDate} - {endDate}</Card.Text>
                <Card.Text>
                    Cake Threshold for Current Period: {pointTarget.toFixed(2)}
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

CompetitionDetails.propTypes = {
    currentPeriod: PropTypes.shape({
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string.isRequired,
    }).isRequired,
    pointTarget: PropTypes.number.isRequired,
    isUserJoined: PropTypes.bool.isRequired,
    onJoinClick: PropTypes.func.isRequired,
    competitionId: PropTypes.string.isRequired,
    competitionName: PropTypes.string.isRequired,
};

export default CompetitionDetails;
